<ng-container>
  <app-header *ngIf="!esEmbebido && logueado"></app-header>

  <section [ngClass]="{'container-fluid main-container': logueado}">
    <div [ngClass]="{'mb-5 pb-5': !esEmbebido && logueado}">
      <router-outlet></router-outlet>
    </div>
  </section>

  <ca-footer *ngIf="!esEmbebido && logueado" disclaimer="Caser® Seguros. {{'FOOTER.DISCLAIMER' | translate}}"
    [isProduction]="false" [version]="version" [year]="anio" [appName]="nombre" [style.z-index]="10"></ca-footer>
</ng-container>
<input type="hidden" name="contenedorIFrame" id="contenedorIFrame" [value]="contenedor"/>

<div class="message-container">
  <app-global-message></app-global-message>
</div>